'use client';
import { TypeBlockPageSection } from '@fm-nx/contentful-types';
import LinkWrapper from '../link-wrapper/link-wrapper';
import TextMarkdown from '../text-markdown/text-markdown';
import { useContentfulInspectorMode, useContentfulLiveUpdates } from '@contentful/live-preview/react';

export const PageSectionContent = (props: TypeBlockPageSection<'WITHOUT_UNRESOLVABLE_LINKS'>) => {
    const updatedData = useContentfulLiveUpdates(props);
    const inspectorProps = useContentfulInspectorMode({ entryId: updatedData?.sys?.id });

    return (
        <div className="mx-6 space-y-6 md:mx-0">
            <h2
                {...inspectorProps({
                    fieldId: 'overline',
                })}
                className="h5 overline"
            >
                {updatedData?.fields.overline}
            </h2>
            <h3
                className="h-xl"
                {...inspectorProps({
                    fieldId: 'headerText',
                })}
            >
                {updatedData?.fields?.headerText}
            </h3>
            {updatedData?.fields.paragraph && (
                <div>
                    <TextMarkdown
                        {...inspectorProps({
                            fieldId: 'paragraph',
                        })}
                        text={updatedData?.fields.paragraph || ''}
                    />
                </div>
            )}
            {updatedData?.fields.links && (
                <ul
                    className="flex flex-wrap gap-x-8 gap-y-4"
                    {...inspectorProps({
                        fieldId: 'links',
                    })}
                >
                    {updatedData?.fields.links.map((link) => {
                        if (!link) return null;
                        return (
                            <li key={`link-${link.sys.id}`} className="inline-block">
                                <LinkWrapper
                                    className="inline-block text-gray-900 h-sm font-headline border-b-out"
                                    page={link.fields.linkPage}
                                >
                                    {link.fields.linkText}
                                </LinkWrapper>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default PageSectionContent;
